import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import AuthPage from "./pages/AuthPage";
import Dashboard from "./pages/Dashboard";
import TournamentPage from "./pages/TournamentPage";
import ProfilePage from "./pages/ProfilePage";
import RulesPage from "./pages/RulesPage";
import AdminPage from "./pages/AdminPage";
import { MyTournamentsPage, PublicTournamentsPage } from "./pages/TournamentLists";
import { AppShell } from "./components/AppShell";
import LandingPage from "./pages/LandingPage";
import LegalPage from "./pages/LegalPage";
import { CookieConsent, applyConsent } from "./components/CookieConsent";

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading)
    return <div className="min-h-screen grid place-items-center text-slate-400 font-mono text-xs tracking-widest" data-testid="app-loading">CARICAMENTO…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <AppShell>{children}</AppShell>;
};

const PublicOnly = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return null;
  return user ? <Navigate to="/" replace /> : children;
};

const Home = () => {
  const { user, loading } = useAuth();
  if (loading) return null;
  return user ? <AppShell><Dashboard /></AppShell> : <LandingPage />;
};

applyConsent();

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<PublicOnly><AuthPage /></PublicOnly>} />
            <Route path="/" element={<Home />} />
            <Route path="/tournament/:tid" element={<Protected><TournamentPage /></Protected>} />
            <Route path="/profile" element={<Protected><ProfilePage /></Protected>} />
            <Route path="/tornei" element={<Protected><MyTournamentsPage /></Protected>} />
            <Route path="/tornei-pubblici" element={<Protected><PublicTournamentsPage /></Protected>} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/regolamento" element={<RulesPage />} />
            <Route path="/privacy" element={<LegalPage doc="privacy" />} />
            <Route path="/termini" element={<LegalPage doc="termini" />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <CookieConsent />
        </BrowserRouter>
        <Toaster theme="dark" position="top-center" richColors visibleToasts={2} duration={2500} />
      </AuthProvider>
    </div>
  );
}

export default App;
